import React from 'react';

import Modals from '../../Constants/modals';

import ModalManager from './ModalManager';
import SendDesktopVersionModal from '../Customer/SendDesktopVersionModal';

import UserSearchModal from '../Customer/UserSearchModal';
import NonCustomerEmailModal from '../NonCustomerEmailModal';
import SendMovieModal from '../Customer/SendMovieModal';
import SendDemoEmailModal from '../Customer/SendDemoEmailModal';
import SupportLoginModal from "../Modals/SupportLogin/SupportLoginModal";

const TopNavigationModalManager = ({}) => {
    const modalsComponents = {
        [Modals.SupportLogin]: SupportLoginModal,
        [Modals.SendDesktopVersion]: SendDesktopVersionModal,
        [Modals.UserSearch]: UserSearchModal,
        [Modals.NonCustomerEmail]: NonCustomerEmailModal,
        [Modals.SendMovie]: SendMovieModal,
        [Modals.SendDemoEmail]: SendDemoEmailModal,
    };

    return <ModalManager modals={modalsComponents} />;
};

export default TopNavigationModalManager;
